// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"6cd5b976","398":"f3046c66","620":"e0107da6"}[chunkId] + ".chunk.js";
};